import { TimesheetStatusEnum } from './../../store/slices/timesheet/timesheetDetailSlice'
import { useSelector } from 'react-redux'
import { TimesheetStoreState } from '../../store/timesheetStore'

/**
 * Custom hook to check if the timesheet is approved.
 *
 * @returns A boolean that informs if the timesheet has been approved.
 */
export const useIsTimesheetApproved = (): boolean => {
	const timesheetPage = useSelector((state: TimesheetStoreState) => state.timesheetPage)
	if (!timesheetPage) return false
	return timesheetPage.status === TimesheetStatusEnum.Approved
}

/**
 * Hook that indicates whether the timesheet is in edit mode by the approver.
 * Considers the ReadyForEdit, Edited, AutoSubmitted, SubmittedWithoutChanges and Submitted states.
 */
export const useIsTimesheetReadyForEdit = (): boolean => {
	const timesheetPage = useSelector((state: TimesheetStoreState) => state.timesheetPage)
	if (!timesheetPage) return false

	return (
		timesheetPage.status === 'ReadyForEdit' ||
		timesheetPage.status === TimesheetStatusEnum.Edited ||
		timesheetPage.status === TimesheetStatusEnum.AutoSubmitted ||
		timesheetPage.status === TimesheetStatusEnum.SubmittedWithoutChanges ||
		timesheetPage.status === TimesheetStatusEnum.Submitted
	)
}
